var _defs, _circle, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenralCargo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        fill: #51bb7c;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #51bb7c;\n        stroke-width: 2.5px;\n      }\n\n      .st1 {\n        opacity: .2;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 65,
    cy: 65,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 40.231,
    y: 28.244,
    width: 49.537,
    height: 13.619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.646 14.441 71.354 14.441 74.189 28.244 55.811 28.244 58.646 14.441"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65 62.725 28.254 65.746 39.589 112.75 90.411 112.75 101.746 65.746 65 62.725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "35.076 65.185 35.076 41.863 94.924 41.863 94.924 65.185"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.008,
    y1: 49.145,
    x2: 65.01,
    y2: 71.54
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.189,
    y1: 27.52,
    x2: 87.791,
    y2: 41.122
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65,
    y1: 28.463,
    x2: 78.337,
    y2: 41.801
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.222,94.332v-4.589h7.571v13.5c-3.646.587-6.604.88-8.872.88-4.054,0-6.84-1.083-8.356-3.251-1.517-2.167-2.275-5.608-2.275-10.326s.79-8.12,2.371-10.211,4.271-3.136,8.069-3.136c2.372,0,4.935.268,7.687.803l1.377.268-.152,4.092c-3.059-.331-5.564-.497-7.515-.497s-3.321.229-4.111.688c-.791.459-1.371,1.308-1.74,2.544-.37,1.236-.555,3.353-.555,6.349s.369,5.093,1.109,6.291c.739,1.198,2.269,1.797,4.589,1.797l3.174-.152v-5.049h-2.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenralCargo);
export default __webpack_public_path__ + "static/media/genral_cargo.df49038d262a93348fc09fba98ceb7fa.svg";
export { ForwardRef as ReactComponent };